import { utils } from './-global.min.js'

const {
  formatPrice,
  all,
  one
} = utils

class HHProductCardSwatches extends HTMLElement {
  constructor() {
    super()

    this.$swatches = all('.js-swatch__button', this)
    this.currentSwatch = this.dataset.currentSwatch

    this.clickSwatch = this.clickSwatch.bind(this)
    this._updateOptionState = this._updateOptionState.bind(this)
    this._updateMasterId = this._updateMasterId.bind(this)
    this._getVariantData = this._getVariantData.bind(this)
    this._updateURL = this._updateURL.bind(this)
    this._updateMedia = this._updateMedia.bind(this)
    this._updatePrice = this._updatePrice.bind(this)
    this._updateActiveSwatchButton = this._updateActiveSwatchButton.bind(this)
  }

  connectedCallback() {
    this.attachListeners()
    this._updateMasterId()
  }

  disconnectedCallback() {
    this.removeListeners()
  }

  attachListeners() {
    this.$swatches.forEach((item) => {
      item.addEventListener('click', (event) => this.clickSwatch(item))
    }, false)
  }

  removeListeners() {
    this.$swatches.forEach((item) => {
      item.removeEventListener('click', (event) => this.clickSwatch(item))
    })
  }

  clickSwatch(item) {
    const swatch = item.dataset.value
    if (swatch == this.currentSwatch) return
    this.currentSwatch = swatch

    this._updateOptionState(item)
    this._updateActiveSwatchButton()
  }

  _updateOptionState(item) {
    this._updateMasterId()
    this._updateMedia()
    this._updatePrice()
    this._updateURL()
  }

  _updateMasterId() {
    this.currentVariant = this._getVariantData().find((variant) => variant['option1'] === this.currentSwatch && variant.available)
  }

  _getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelectorAll('[type="application/json"]')[0].textContent)
    return this.variantData
  }

  _updateURL() {
    if (!this.currentVariant) return

    this.closest('.product-card').querySelector('.js-card-wrapper').setAttribute('href', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  _updateMedia() {
    if (!this.currentVariant || !this.currentSwatch) return

    const featuredImage = this.currentVariant.featured_image
    const featuredImageSrc = `${featuredImage.src.replace('https:', '')}&width=533`
    let imageContents = this._buildImage(featuredImage)
    const images = JSON.parse(this.querySelectorAll('[type="application/json"]')[1].textContent)
    const secondFeaturedImage = images.find((image) => image.alt === this.currentSwatch && image.src !== featuredImageSrc) || null
    imageContents += this._buildImage(secondFeaturedImage)

    this.closest('.product-card').querySelector('.js-media__wrapper').innerHTML = imageContents
  }

  _buildImage(image, w = 533) {
    if(!image) return ''
    return `<img src="${image.src}&width=${w}" alt="${image.alt}" loading="lazy" class="motion-reduce" />`
  }

  _updatePrice() {
    if (!this.currentVariant) return;

    console.log(this.currentVariant);

    // Access the .product-card element first
    const productCard = this.closest('.product-card');
    if (!productCard) {
        console.error('product card not found');
        return;
    }

    // Access the .card-wrapper as a child of .product-card
    const cardWrapper = one('.card-wrapper', productCard);
    if (!cardWrapper) {
        console.error('card wrapper not found');
        return;
    }

    // Get the price elements and discount percent directly from productCard
    const priceElem = one('.js-product-card__price', productCard);
    if (!priceElem) {
        console.error('price element not found');
        return;
    }

    const isPriceVaries = priceElem.dataset.priceVaries === 'true';
    const discountPercent = parseFloat(productCard.dataset.discountPercent) || 0;
    console.log('my discount percent is ' + discountPercent);
    // Get the variant price in cents and convert to dollars
    let variantPrice = this.currentVariant.price / 100;

    // Calculate the compare price (original price) in dollars based on the discount percent
    const comparePrice = variantPrice * (1 - discountPercent);
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        variantPrice = this.currentVariant.compare_at_price / 100;
    }

    // Format the prices as strings with dollar signs, removing ".00" if present
    const variantPriceStr = `$${variantPrice.toFixed(2).replace('.00', '')}`;
    const comparePriceStr = `$${comparePrice.toFixed(2).replace('.00', '')}`;

    console.log(`Variant price (sale price): ${variantPriceStr}, Compare price (regular price): ${comparePriceStr}`);
    console.log('my discount is ' + discountPercent);
    // Build HTML based on discount availability
    if (discountPercent != 0) {
    priceElem.innerHTML = `
        <div class="price__regular">
              <dl>
          <dt>
            <span aria-hidden="true" class="visually-hidden visually-hidden--inline">Regular price</span>
          </dt>
          <dd>
            <p class="no-margin price-item price-item--regular product-panel__price" id="price-">
              ${isPriceVaries ? '<span>From </span>' : ''}
              <del class="price__ml">${variantPriceStr}</del>
              <ins>${comparePriceStr}</ins>
            </p>
          </dd>
          </dl>
        </div>
        <small class="caption uppercase hidden">
              <dl>
          <dt aria-hidden="true" class="visually-hidden">Unit price</dt>
          <dd>
            <span></span>
            <span aria-hidden="true">/</span>
            <span aria-hidden="true" class="visually-hidden">&nbsp;per&nbsp;</span>
            <span></span>
          </dd>
          </dl>
        </small>
    `;
    }
    else {
        priceElem.innerHTML = `
        <div class="price__regular">
              <dl>
          <dt>
            <span aria-hidden="true" class="visually-hidden visually-hidden--inline">Regular price</span>
          </dt>
          <dd>
            <p class="no-margin price-item price-item--regular product-panel__price" id="price-">
              ${isPriceVaries ? '<span>From </span>' : ''}
              <span class="price__ml">${comparePriceStr}</span>
            </p>
          </dd>
          </dl>
        </div>
        <small class="caption uppercase hidden">
              <dl>
          <dt aria-hidden="true" class="visually-hidden">Unit price</dt>
          <dd>
            <span></span>
            <span aria-hidden="true">/</span>
            <span aria-hidden="true" class="visually-hidden">&nbsp;per&nbsp;</span>
            <span></span>
          </dd>
          </dl>
        </small>
    `;  
    }
    // Update aria-label dynamically
    const title = productCard.querySelector('.card-information__text')?.textContent.trim();
    const excerpt = productCard.querySelector('.card-information__excerpt')?.textContent.trim();
    const fromText = isPriceVaries ? 'From ' : '';
    const priceText = discountPercent > 0 ? `${variantPriceStr} ${comparePriceStr}` : `${variantPriceStr}`;

    cardWrapper.setAttribute(
        'aria-label',
        `${title} ${fromText}${priceText} ${excerpt}`
    );

    console.log('aria-label updated successfully');
}

    
  
  _updateActiveSwatchButton() {
    this.$swatches.forEach((item) => item.classList[item.dataset.value === this.currentSwatch ? 'add': 'remove']('swatch__button--active'))
  }
}

customElements.define('hh-product-card-swatches', HHProductCardSwatches)